// JAB's job-note mapping (labelInternalNotes* answers kept private and aggregated
// into Private Notes, Parts retired) applies to the enrolled activity ids, or to
// every JAB activity when REACT_APP_PRIVATE_NOTES_ALL_JAB_ACTIVITIES is "true"
// (the private service carries the same switch). Generic private fields use a
// separate build-time availability switch; the API independently authorizes
// live organization membership and the exact instance.
export const PRIVATE_NOTES_ORG = "332a9d47-6e36-11e8-a392-061714f61e3e";
const validId = value => typeof value === "string" && /^[A-Za-z0-9][A-Za-z0-9:_-]{0,127}$/.test(value);
export function isPrivateNotesActivity(activity, orgId) {
  if (orgId !== PRIVATE_NOTES_ORG) return false;
  const activityId = typeof activity === "string" ? activity : activity && (activity.activityId || activity.id);
  if (!validId(activityId)) return false;
  if (process.env.REACT_APP_PRIVATE_NOTES_ALL_JAB_ACTIVITIES === "true") return true;
  try {
    const ids = JSON.parse(process.env.REACT_APP_PRIVATE_NOTES_ACTIVITY_IDS || "[]");
    return Array.isArray(ids) && ids.every(validId) && new Set(ids).size === ids.length && ids.includes(activityId);
  } catch (_) { return false; }
}
export function isPrivateAnswerActivity(activity, orgId) {
  const activityId = typeof activity === "string" ? activity : activity && (activity.activityId || activity.id);
  return validId(orgId) && validId(activityId) && (process.env.REACT_APP_PRIVATE_ANSWERS_ENABLED === "true" || isPrivateNotesActivity(activity, orgId));
}
export function privateNotesContext(activity, orgId) {
  if (!activity || !isPrivateAnswerActivity(activity, orgId) || !validId(activity.instanceId)) return null;
  return { protocolVersion: 1, orgId, activityId: activity.activityId || activity.id, instanceId: activity.instanceId };
}
export function normalizePrivateNotesContext(context) {
  if (!context || context.protocolVersion !== 1) return null;
  return privateNotesContext(context, context.orgId);
}
